import axios from "axios";
import i18n from "../i18n";
import { axiosInstance } from "../App";
  export async function getUser():Promise<any> {
    
    return axiosInstance
      .get(process.env.REACT_APP_API_HOST_TEST + "db/testConnection", {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language, // Add current language
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  }
  export async function setUser(payload: any):Promise<any> {
    const body = {
    email: payload.email,
    password: payload.password,
    full_name: payload.fullName,
    position: payload.position,
    company: payload.company,
    country: payload.country,
    industry: payload.industry,
    usecase: payload.primaryUseCase
    };
    return axiosInstance
      .post(process.env.REACT_APP_API_HOST_TEST + "registration", body, {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language, // Add current language
        },
      })
      .then((response) => {
        return response;
      });
  }